import { SUCCESS } from '@App/app/configs/toastr-events.config';
import { SUCCESS_TOASTR_CONFIG } from '@App/app/configs/toastr-messages.config';
import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { UsersHttpService } from 'src/app/pages/users/users-http.service';
import {
  DISABLE_USER_FAILED,
  DISABLE_USER_SUCCESS,
  FAILED,
} from '../../../../configs/toastr-events.config';
import { WARNING_TOASTR_CONFIG } from '../../../../configs/toastr-messages.config';
import { disableUser, disableUserFailed, disableUserSuccess } from '../actions/users.actions';

@Injectable()
export class DisableUserEffects {
  constructor(
    private actions: Actions,
    private usersHttpService: UsersHttpService,
    private toastrService: NbToastrService,
  ) {}

  disableUser = createEffect(() => {
    return this.actions.pipe(
      ofType(disableUser),
      mergeMap(({ userId }) => {
        return this.usersHttpService.disableUser(userId).pipe(
          map(() => {
            return disableUserSuccess({ id: userId });
          }),
          catchError(() => of(disableUserFailed())),
        );
      }),
    );
  });

  disableUserSuccess = createEffect(
    () => {
      return this.actions.pipe(
        ofType(disableUserSuccess),
        tap(() => {
          this.toastrService.show(DISABLE_USER_SUCCESS, SUCCESS, {
            ...SUCCESS_TOASTR_CONFIG,
          });
        }),
      );
    },
    { dispatch: false },
  );

  disableUserFailed = createEffect(
    () => {
      return this.actions.pipe(
        ofType(disableUserFailed),
        tap(() => {
          this.toastrService.show(DISABLE_USER_FAILED, FAILED, {
            ...WARNING_TOASTR_CONFIG,
          });
        }),
      );
    },
    { dispatch: false },
  );
}
